import { render, staticRenderFns } from "./KanbanBoardIndex.vue?vue&type=template&id=2b9dc79b&"
import script from "./KanbanBoardIndex.vue?vue&type=script&lang=js&"
export * from "./KanbanBoardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports